<div class="button-grid">
  <div class="button-grid__item" *hasRole="saleRoles">
    <app-card-button
      [disabled]="false"  
      [buttonSize]="CardButtonSize.Long"
      [buttonIcon]="['fas', 'umbrella-beach']"
      [buttonBackground]="CardButtonBackground.Tertiary"
      (clicked)="searchTrip()">
      {{ "webPos.Trip.TripButton" | translate}}
    </app-card-button>
  </div>
  <div class="button-grid__item" *hasRole="saleRoles">
    <app-card-button [disabled]="false" [buttonSize]="CardButtonSize.Long"
      [buttonIcon]="['fas', 'plane']" [buttonBackground]="CardButtonBackground.Tertiary"
      (clicked)="goToSaleFlyTicket()">
      {{ "webPos.FlyTicketButton" | translate}}
    </app-card-button>
  </div>
  <div class="button-grid__item" *hasRole="saleRoles">
    <app-card-button [disabled]="false" [buttonSize]="CardButtonSize.Long"
      [buttonIcon]="['fas', 'earth-europe']" [buttonBackground]="CardButtonBackground.Tertiary"
      (clicked)="goToETravelTicket()" >
      {{ "webPos.ETravel" | translate}}
    </app-card-button>
  </div>
  <div class="button-grid__item" *hasRole="saleRoles">
    <app-card-button
      [disabled]="false"
      [buttonSize]="CardButtonSize.Long"
      [buttonIcon]="['fas', 'ticket']"
      [buttonBackground]="CardButtonBackground.Tertiary"
      (clicked)="goToSaleVoucher()">
      {{ "webPos.Voucher.Voucher" | translate}}
    </app-card-button>
  </div>
</div>
